import { Redirect, useLocalSearchParams } from "expo-router";

/** Alter Pfad. Recovery liegt unter /auth/recovery, der Code bleibt in der Adresse. */
export default function LegacySetPassword() {
  const params = useLocalSearchParams();
  return <Redirect href={{ pathname: "/auth/recovery", params }} />;
}
